import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumToArray',
    standalone: true
})
export class EnumToArrayPipe implements PipeTransform {
    transform(data) {
        const temp = [];
        Object.keys(data).forEach(k => {
            temp.push(data[k]);
        });
        return temp;
    }
}
